import { addDays, format } from 'date-fns';
import { EmissorOrderScreenStatus } from '../types/emissor-order-history';
export const EMISSOR_ONBOARDING_SAMPLE_ORDER_ID = 'demo-emissor-onboarding-order';
const SAMPLE_CREDIT_DATE_DAYS_AHEAD = 10;
export function buildEmissorOnboardingSampleOrders(today = new Date()) {
    const creditDate = addDays(today, SAMPLE_CREDIT_DATE_DAYS_AHEAD);
    return [
        {
            id: EMISSOR_ONBOARDING_SAMPLE_ORDER_ID,
            protocol: 'DEMO-EXEMPLO',
            description: 'Exemplo',
            product: { id: 'demo-product-meal', name: 'Auxílio refeição' },
            totalAmount: 1000,
            calculationType: 'MONTHLY',
            discountType: null,
            scheduledCreditDate: format(creditDate, 'yyyy-MM-dd'),
            competenceDate: format(creditDate, 'yyyy-MM'),
            status: 'PROCESSING',
            screenStatus: EmissorOrderScreenStatus.RELEASING_CREDIT,
            payment: null,
            createdAt: today.toISOString(),
            updatedAt: today.toISOString(),
        },
    ];
}
export const EMISSOR_ONBOARDING_SAMPLE_TRACKING_CARDS = [
    {
        cardTrackingId: 'demo-emissor-onboarding-tracking-1',
        trackingCode: 'TR000000897IC',
        trackingUrl: 'https://example.com/track/TR000000897IC',
        status: 'IN_PRODUCTION',
        createdAt: '2026-08-01T12:00:00.000Z',
        updatedAt: '2026-08-01T12:00:00.000Z',
    },
];
